import Fuse from 'fuse.js';

import type { NationalityFacet } from './FilterNationality';

export const fuzzyFilter = ({
  items,
  searchText,
}: {
  items: NationalityFacet[];
  searchText: string;
}): NationalityFacet[] => {
  const fuse = new Fuse(items, {
    isCaseSensitive: false,
    shouldSort: true,
    includeScore: false,
    location: 0,
    threshold: 0.4,
    distance: 150,
    includeMatches: false, // We can set this to true to get indices that match the search text if we want to bold the matching substrings later
    keys: ['name'],
  });

  return fuse.search(searchText).map(({ item }) => item);
};
